<script lang="ts">
  import StatusTag from "@kontextwerk/web-sdk/ui/display/StatusTag.svelte"
  import { RICH_TOOLTIP_CLASS } from "../../../../../_shared/_logic/rich-tooltips"
  let {
    tag,
  }: {
    tag: {
      label: string
      subLabel?: string | null
      numberLabel: string
      tooltip?: string | null
      tooltipHtml?: boolean
    }
  } = $props()
</script>

<StatusTag
  variant="neutral"
  size="sm"
  label={tag.label}
  subLabel={tag.subLabel ?? undefined}
  iconText={tag.numberLabel}
  tooltipContent={tag.tooltip ?? undefined}
  tooltipHtml={tag.tooltipHtml ?? false}
  tooltipClassName={RICH_TOOLTIP_CLASS}
  disableTitle={true}
/>
